import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'

interface IProps {
    className?: string
}

const HistoryCashbackPage: React.FC<IProps> = ({className}) => {
    return <PageLayout title={'Reward History'} className={className}></PageLayout>
}

export default HistoryCashbackPage
